import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import HomePage from "./pages/HomePage";
import GrassPage from "./pages/GrassPage";
import SoilPage from "./pages/SoilPage";
import RockPage from "./pages/RockPage";
import MulchPage from "./pages/MulchPage";
import ContactPage from "./pages/ContactPage";
import SandPage from "./pages/SandPage";
import QuotePage from "./pages/QuotePage";
import ProductsPage from "./pages/ProductsPage";
import ServicesPage from "./pages/ServicesPage";
import SodDeliveryPage from "./pages/SodDeliveryPage";
import BulkDeliveryPage from "./pages/BulkDeliveryPage";
import AreasPage from "./pages/AreasPage";
import AreaDetailPage from "./pages/AreaDetailPage";
import AboutPage from "./pages/AboutPage";
import BlogPostPage from "./pages/BlogPostPage";
import NotFound from "./pages/NotFound";
import AuthPage from "./pages/AuthPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <LanguageProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
          <Routes>
            {/* Redirect root to English */}
            <Route path="/" element={<Navigate to="/en" replace />} />
            
            {/* English Routes */}
            <Route path="/en" element={<HomePage />} />
            <Route path="/en/products" element={<ProductsPage />} />
            <Route path="/en/grass" element={<GrassPage />} />
            <Route path="/en/grass/:product" element={<GrassPage />} />
            <Route path="/en/rock" element={<RockPage />} />
            <Route path="/en/mulch" element={<MulchPage />} />
            <Route path="/en/soil" element={<SoilPage />} />
            <Route path="/en/sand" element={<SandPage />} />
            <Route path="/en/services" element={<ServicesPage />} />
            <Route path="/en/services/sod-delivery" element={<SodDeliveryPage />} />
            <Route path="/en/services/bulk-delivery" element={<BulkDeliveryPage />} />
            <Route path="/en/areas" element={<AreasPage />} />
            <Route path="/en/areas/:areaSlug" element={<AreaDetailPage />} />
            <Route path="/en/blog/:postSlug" element={<BlogPostPage />} />
            <Route path="/en/about" element={<AboutPage />} />
            <Route path="/en/contact" element={<ContactPage />} />
            <Route path="/en/quote" element={<QuotePage />} />
            <Route path="/en/auth" element={<AuthPage />} />
            <Route path="/en/privacy" element={<PrivacyPage />} />
            <Route path="/en/terms" element={<TermsPage />} />
            
            {/* Spanish Routes */}
            <Route path="/es" element={<HomePage />} />
            <Route path="/es/productos" element={<ProductsPage />} />
            <Route path="/es/pasto" element={<GrassPage />} />
            <Route path="/es/pasto/:product" element={<GrassPage />} />
            <Route path="/es/roca" element={<RockPage />} />
            <Route path="/es/mulch" element={<MulchPage />} />
            <Route path="/es/tierra" element={<SoilPage />} />
            <Route path="/es/arena" element={<SandPage />} />
            <Route path="/es/servicios" element={<ServicesPage />} />
            <Route path="/es/servicios/entrega-cesped" element={<SodDeliveryPage />} />
            <Route path="/es/servicios/entrega-granel" element={<BulkDeliveryPage />} />
            <Route path="/es/areas" element={<AreasPage />} />
            <Route path="/es/areas/:areaSlug" element={<AreaDetailPage />} />
            <Route path="/es/blog/:postSlug" element={<BlogPostPage />} />
            <Route path="/es/nosotros" element={<AboutPage />} />
            <Route path="/es/contacto" element={<ContactPage />} />
            <Route path="/es/cotizar" element={<QuotePage />} />
            <Route path="/es/auth" element={<AuthPage />} />
            <Route path="/es/privacidad" element={<PrivacyPage />} />
            <Route path="/es/terminos" element={<TermsPage />} />
            
            {/* Catch-all */}
            <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
